



// import React, { useState, useEffect } from 'react';
// import {
//     Modal,
//     Box,
//     Typography,
//     Button,
//     Card,
//     CardContent,
//     Divider,
//     IconButton,
//     Tooltip,
//     Chip,
//     Stack,
//     Alert,
//     CircularProgress,
//     Grid,
//     Paper,
// } from '@mui/material';
// import DeleteIcon from '@mui/icons-material/Delete';
// import PersonIcon from '@mui/icons-material/Person';
// import AccessTimeIcon from '@mui/icons-material/AccessTime';
// import OpenInNewIcon from '@mui/icons-material/OpenInNew';
// import ListIcon from '@mui/icons-material/List';
// import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
// import LocationOnIcon from '@mui/icons-material/LocationOn';
// import ScheduleIcon from '@mui/icons-material/Schedule';
// import EventNoteIcon from '@mui/icons-material/EventNote';
// import EventRepeatIcon from '@mui/icons-material/EventRepeat';
// import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
// import TodayIcon from '@mui/icons-material/Today';
// import WarningIcon from '@mui/icons-material/Warning';
// import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
// import TwentyFourMpIcon from '@mui/icons-material/TwentyFourMp';
// import { format, parseISO, addDays, isBefore, isToday, startOfDay } from 'date-fns';
// import { useNavigate } from 'react-router-dom';
// import { fetchAllTrainers } from 'helpers/user_helper';

// const style = {
//     position: 'absolute',
//     top: '50%',
//     left: '50%',
//     transform: 'translate(-50%, -50%)',
//     width: 700,
//     maxWidth: '95vw',
//     bgcolor: 'background.paper',
//     border: '2px solid #000',
//     boxShadow: 24,
//     p: 3,
//     maxHeight: '90vh',
//     overflowY: 'auto',
// };

// const trainingTypes = [
//     { id: 1, name: "Safety", color: "#f44336" },
//     { id: 2, name: "IT", color: "#2196f3" },
//     { id: 3, name: "Technical", color: "#4caf50" },
//     { id: 4, name: "Driver", color: "#ff9800" }
// ];

// // Assessment type data for Technical training
// const assessmentTypeData = [
//     { 
//         id: 'bronze', 
//         name: 'Bronze', 
//         color: '#CD7F32', 
//         description: 'Basic technical skills assessment',
//         icon: '🥉'
//     },
//     { 
//         id: 'silver', 
//         name: 'Silver', 
//         color: '#C0C0C0', 
//         description: 'Intermediate technical skills assessment',
//         icon: '🥈'
//     },
//     { 
//         id: 'gold', 
//         name: 'Gold', 
//         color: '#FFD700', 
//         description: 'Advanced technical skills assessment',
//         icon: '🥇'
//     }
// ];

// const TrainingDetailsModal = ({ isOpen, onClose, trainings, onDeleteTraining, onGenerateBatch, type, userInfo, onUpdateTraining }) => {
//     const [trainers, setTrainers] = useState([]);
//     const [loadingTrainers, setLoadingTrainers] = useState(false);
//     const [use24HourFormat, setUse24HourFormat] = useState(true);
//     const navigate = useNavigate();

//     // Helper function to check if date is in the past
//     const isDateInPast = (dateString) => {
//         if (!dateString) return false;
//         try {
//             const date = parseISO(dateString);
//             const today = startOfDay(new Date());
//             return isBefore(date, today) && !isToday(date);
//         } catch (error) {
//             return false;
//         }
//     };

//     // Convert 24-hour time to 12-hour format
//     const convertTo12HourFormat = (time24) => {
//         if (!time24) return '';
//         if (time24.includes('AM') || time24.includes('PM')) return time24;
        
//         const match = time24.match(/(\d{1,2}):(\d{2})/);
//         if (!match) return time24;
        
//         let hour = parseInt(match[1]);
//         const minute = match[2];
//         const ampm = hour >= 12 ? 'PM' : 'AM';
//         hour = hour % 12 || 12;
//         return `${hour}:${minute} ${ampm}`;
//     };

//     // Convert 12-hour time to 24-hour format
//     const convertTo24HourFormat = (time12) => {
//         if (!time12) return '';
//         if (time12.match(/^([01]?[0-9]|2[0-3]):[0-5][0-9]$/)) return time12;
        
//         const match = time12.match(/(\d{1,2}):(\d{2})\s*(AM|PM)/i);
//         if (!match) return time12;
        
//         let hour = parseInt(match[1]);
//         const minute = match[2];
//         const ampm = match[3].toUpperCase();
        
//         if (ampm === 'PM' && hour !== 12) hour += 12;
//         if (ampm === 'AM' && hour === 12) hour = 0;
        
//         return `${hour.toString().padStart(2, '0')}:${minute}`;
//     };

//     // Helper function to format time display based on selected format
//     const formatTimeDisplay = (timeStr) => {
//         if (!timeStr) return '';
        
//         if ((timeStr.includes('AM') || timeStr.includes('PM')) && use24HourFormat) {
//             return convertTo24HourFormat(timeStr);
//         }
        
//         if (!timeStr.includes('AM') && !timeStr.includes('PM') && !use24HourFormat) {
//             return convertTo12HourFormat(timeStr);
//         }
        
//         return timeStr;
//     };

//     // Function to extract time from concatenated type
//     const extractTimeFromType = (typeString) => {
//         if (!typeString) return null;
        
//         const timePattern = /(\d{1,2}:\d{2}\s*(?:AM|PM|am|pm)?)\s*-\s*(\d{1,2}:\d{2}\s*(?:AM|PM|am|pm)?)/gi;
//         const match = timePattern.exec(typeString);
        
//         if (match && match.length >= 3) {
//             return {
//                 startTime: match[1],
//                 endTime: match[2],
//                 fullTimeRange: `${formatTimeDisplay(match[1])} - ${formatTimeDisplay(match[2])}`
//             };
//         }
        
//         return null;
//     };

//     // Function to extract training days from concatenated type
//     const extractDaysFromType = (typeString) => {
//         if (!typeString) return null;
        
//         const daysPattern = /-\s*(\d+)\s*(?:Day|Days|day|days)/i;
//         const match = daysPattern.exec(typeString);
        
//         if (match && match.length >= 2) {
//             return parseInt(match[1]);
//         }
        
//         return null;
//     };

//     // Function to extract original type without time
//     const extractOriginalType = (typeString) => {
//         if (!typeString) return typeString;
        
//         const timePattern = /-\s*\d{1,2}:\d{2}\s*(?:AM|PM|am|pm)?\s*-\s*\d{1,2}:\d{2}\s*(?:AM|PM|am|pm)?$/i;
//         const typeWithoutTime = typeString.replace(timePattern, '').trim();
        
//         return typeWithoutTime.replace(/-\s*$/, '').trim();
//     };

//     // Function to get date range string for display (e.g., "16-20")
//     const getDateRangeString = (startDate, endDate) => {
//         if (!startDate || !endDate) return '';
//         try {
//             const start = new Date(startDate);
//             const end = new Date(endDate);
//             const startDay = format(start, 'd');
//             const endDay = format(end, 'd');
//             const startMonth = format(start, 'MMM');
//             const endMonth = format(end, 'MMM');
            
//             if (startMonth === endMonth) {
//                 return `${startDay}-${endDay} ${startMonth}`;
//             } else {
//                 return `${startDay} ${startMonth} - ${endDay} ${endMonth}`;
//             }
//         } catch (error) {
//             return '';
//         }
//     };

//     // Function to get actual time for training display
//     const getTrainingTimeInfo = (training) => {
//         if (training.startTime && training.endTime) {
//             const startTimeFormatted = formatTimeDisplay(training.startTime);
//             const endTimeFormatted = formatTimeDisplay(training.endTime);
//             return {
//                 startTime: training.startTime,
//                 endTime: training.endTime,
//                 timeDisplay: `${startTimeFormatted} - ${endTimeFormatted}`,
//                 duration: training.duration || 0,
//                 source: 'direct'
//             };
//         }
        
//         if (training.type && typeof training.type === 'string') {
//             const timeFromType = extractTimeFromType(training.type);
//             if (timeFromType) {
//                 return {
//                     startTime: timeFromType.startTime,
//                     endTime: timeFromType.endTime,
//                     timeDisplay: timeFromType.fullTimeRange,
//                     duration: training.duration || 0,
//                     source: 'type'
//                 };
//             }
//         }
        
//         if (training.timeSlotLabel) {
//             const timePattern = /(\d{1,2}:\d{2}\s*(?:AM|PM|am|pm)?)\s*-\s*(\d{1,2}:\d{2}\s*(?:AM|PM|am|pm)?)/;
//             const match = timePattern.exec(training.timeSlotLabel);
//             if (match) {
//                 return {
//                     startTime: match[1],
//                     endTime: match[2],
//                     timeDisplay: `${formatTimeDisplay(match[1])} - ${formatTimeDisplay(match[2])}`,
//                     duration: training.duration || 0,
//                     source: 'timeslot'
//                 };
//             }
//             return {
//                 startTime: training.startTime || '',
//                 endTime: training.endTime || '',
//                 timeDisplay: training.timeSlotLabel,
//                 duration: training.duration || 0,
//                 source: 'timeslot'
//             };
//         }
        
//         return {
//             startTime: '',
//             endTime: '',
//             timeDisplay: 'Time not specified',
//             duration: 0,
//             source: 'none'
//         };
//     };

//     // Check if user has permission to view training calendar
//     const canViewTrainingCalendar = () => {
//         const allowedRoles = ["Tata Depot Manager", "Tata Trainer", "Tata Project Manager", "Admin", "Super Admin"];
//         return allowedRoles.includes(type);
//     };

//     // Check if user can generate batches
//     const canGenerateBatch = () => {
//         return ["Tata Project Manager", "Admin", "Super Admin"].includes(type);
//     };

//     // Check if user can delete trainings
//     const canDeleteTraining = () => {
//         return ["Tata Project Manager", "Admin", "Super Admin"].includes(type);
//     };

//     // Filter trainings based on user role
//     const filterTrainingsByRole = (trainingsData) => {
//         if (!trainingsData || !type) return trainingsData;
        
//         let filtered = trainingsData;
        
//         if (type === "Tata Depot Manager" && userInfo?.depot) {
//             const userDepot = userInfo.depot.trim().toLowerCase();
//             filtered = trainingsData.filter(training => {
//                 const trainingDepot = training.depot ? training.depot.trim().toLowerCase() : '';
//                 return trainingDepot === userDepot;
//             });
//         } 
//         else if (type === "Tata Trainer" && userInfo?.trainerId) {
//             filtered = trainingsData.filter(training => 
//                 parseInt(training.trainerId) === parseInt(userInfo.trainerId)
//             );
//         }
        
//         return filtered;
//     };

//     useEffect(() => {
//         if (isOpen && trainings && trainings.length > 0 && canViewTrainingCalendar()) {
//             fetchTrainers();
//         }
//     }, [isOpen, trainings]);

//     const fetchTrainers = async () => {
//         try {
//             setLoadingTrainers(true);
//             const data = await fetchAllTrainers();
//             if (data?.success) {
//                 setTrainers(data?.result || []);
//             }
//         } catch (error) {
//             console.error("Error fetching trainers:", error);
//         } finally {
//             setLoadingTrainers(false);
//         }
//     };

//     const getTrainingTypeColor = (trainingType) => {
//         if (!trainingType) return '#ccc';
//         const originalType = extractOriginalType(trainingType);
//         const type = trainingTypes.find(t => t.name === originalType);
//         return type ? type.color : '#ccc';
//     };

//     const getAssessmentTypeColor = (assessmentType) => {
//         const type = assessmentTypeData.find(t => t.name === assessmentType);
//         return type ? type.color : '#CD7F32';
//     };

//     const getTrainerName = (trainerId) => {
//         const trainer = trainers.find(t => parseInt(t.id) === parseInt(trainerId));
//         return trainer ? trainer.name : `Trainer ID: ${trainerId}`;
//     };

//     const getTotalTrainingHours = (training) => {
//         if (!training) return 0;
        
//         const timeInfo = getTrainingTimeInfo(training);
//         const dailyDuration = timeInfo.duration || training.duration || 0;
//         const trainingDays = parseInt(training.trainingDays) || extractDaysFromType(training.type) || 0;
        
//         return dailyDuration * trainingDays;
//     };

//     const getTrainingScheduleInfo = (training) => {
//         if (!training) return {
//             totalCalendarDays: 0,
//             actualTrainingDays: 0,
//             scheduleDetails: []
//         };
        
//         try {
//             const start = parseISO(training.trainingStartDate);
//             const end = parseISO(training.trainingEndDate);
            
//             let current = new Date(start);
//             const endDate = new Date(end);
//             const scheduleDetails = [];
//             let calendarDays = 0;
//             let trainingDaysCount = 0;
            
//             if (training.batchSchedule && training.batchSchedule.length > 0) {
//                 training.batchSchedule.forEach((schedule) => {
//                     const date = parseISO(schedule.date);
//                     scheduleDetails.push({
//                         date: date,
//                         dayOfWeek: schedule.dayOfWeek || format(date, 'EEEE'),
//                         isTrainingDay: true,
//                         startTime: schedule.startTime || training.startTime,
//                         endTime: schedule.endTime || training.endTime,
//                         duration: schedule.duration || training.duration
//                     });
//                 });
                
//                 trainingDaysCount = training.batchSchedule.length;
                
//                 const dates = training.batchSchedule.map(s => parseISO(s.date)).sort((a, b) => a - b);
//                 if (dates.length > 0) {
//                     const firstDate = dates[0];
//                     const lastDate = dates[dates.length - 1];
//                     calendarDays = Math.ceil((lastDate - firstDate) / (1000 * 60 * 60 * 24)) + 1;
//                 }
//             } else {
//                 while (current <= endDate) {
//                     calendarDays++;
//                     trainingDaysCount++;
                    
//                     scheduleDetails.push({
//                         date: new Date(current),
//                         dayOfWeek: format(current, 'EEEE'),
//                         isTrainingDay: true,
//                         startTime: training.startTime,
//                         endTime: training.endTime,
//                         duration: training.duration
//                     });
                    
//                     current.setDate(current.getDate() + 1);
//                 }
//             }
            
//             return {
//                 totalCalendarDays: calendarDays,
//                 actualTrainingDays: trainingDaysCount,
//                 scheduleDetails: scheduleDetails.sort((a, b) => a.date - b.date)
//             };
//         } catch (error) {
//             console.error("Error calculating schedule:", error);
//             return {
//                 totalCalendarDays: 0,
//                 actualTrainingDays: 0,
//                 scheduleDetails: []
//             };
//         }
//     };

//     const getTrainingDaysInfo = (training) => {
//         if (!training) return { 
//             trainingDays: 0, 
//             trainingDaysText: 'Not specified'
//         };
        
//         const trainingDays = parseInt(training.trainingDays) || extractDaysFromType(training.type) || 0;
//         const actualTrainingDays = parseInt(training.actualTrainingDays) || trainingDays;
        
//         const trainingDaysText = `${trainingDays} day${trainingDays !== 1 ? 's' : ''}`;
//         const actualDaysText = trainingDays !== actualTrainingDays ? ` (Actual: ${actualTrainingDays} days)` : '';
        
//         return {
//             trainingDays: trainingDays,
//             actualTrainingDays: actualTrainingDays,
//             trainingDaysText: trainingDaysText + actualDaysText
//         };
//     };

//     const handleNavigateToAllBatches = (training) => {
//         if (!training) return;
        
//         const timeInfo = getTrainingTimeInfo(training);
        
//         const filters = {
//             trainingName: training.name || '',
//             trainingType: extractOriginalType(training.type) || '',
//             state: training.state || '',
//             depot: training.depot || '',
//             trainerId: training.trainerId || null,
//             startDate: training.trainingStartDate || '',
//             endDate: training.trainingEndDate || '',
//             startTime: timeInfo.startTime,
//             endTime: timeInfo.endTime
//         };
        
//         navigate('/all-batches', { 
//             state: { 
//                 trainingFilters: filters,
//                 message: `Showing batches for "${training.name}"`
//             } 
//         });
        
//         onClose();
//     };

//     const handleNavigateToBatch = (training) => {
//         if (training.batchId) {
//             navigate(`/batch/${training.batchId}`);
//         } else {
//             // If no batch exists, navigate to all-batches with filter
//             const timeInfo = getTrainingTimeInfo(training);
//             const filters = {
//                 trainingName: training.name || '',
//                 trainingType: extractOriginalType(training.type) || '',
//                 state: training.state || '',
//                 depot: training.depot || '',
//                 trainerId: training.trainerId || null,
//                 startDate: training.trainingStartDate || '',
//                 endDate: training.trainingEndDate || '',
//                 startTime: timeInfo.startTime,
//                 endTime: timeInfo.endTime
//             };
//             navigate('/all-batches', { 
//                 state: { 
//                     trainingFilters: filters,
//                     message: `Showing batches for "${training.name}"`
//                 } 
//             });
//         }
//         onClose();
//     };

//     const handleViewAllBatches = () => {
//         navigate('/all-batches');
//         onClose();
//     };

//     const handleGenerateBatchForTraining = (training) => {
//         if (training.batchId) {
//             navigate(`/batch/${training.batchId}`);
//         } else {
//             // If no batch exists, navigate to all-batches with filter
//             const timeInfo = getTrainingTimeInfo(training);
//             const filters = {
//                 trainingName: training.name || '',
//                 trainingType: extractOriginalType(training.type) || '',
//                 state: training.state || '',
//                 depot: training.depot || '',
//                 trainerId: training.trainerId || null,
//                 startDate: training.trainingStartDate || '',
//                 endDate: training.trainingEndDate || '',
//                 startTime: timeInfo.startTime,
//                 endTime: timeInfo.endTime
//             };
//             navigate(`/batch/${training.batchId}`, { 
//                 state: { 
//                     trainingFilters: filters,
//                     message: `Showing batches for "${training.name}"`
//                 } 
//             });
//         }
//         onClose();
//     };

//     const formatDate = (dateString) => {
//         if (!dateString) return 'N/A';
//         try {
//             const date = new Date(dateString);
//             return format(date, 'EEE, MMM dd, yyyy');
//         } catch (error) {
//             return 'N/A';
//         }
//     };

//     const formatDateShort = (dateString) => {
//         if (!dateString) return 'N/A';
//         try {
//             const date = new Date(dateString);
//             return format(date, 'MMM dd');
//         } catch (error) {
//             return 'N/A';
//         }
//     };

//     // Toggle time format
//     const toggleTimeFormat = () => {
//         setUse24HourFormat(!use24HourFormat);
//     };

//     // Filter trainings for this modal view
//     const filteredTrainings = filterTrainingsByRole(trainings || []);

//     // If user doesn't have permission to view training calendar
//     if (isOpen && !canViewTrainingCalendar()) {
//         return (
//             <Modal
//                 open={isOpen}
//                 onClose={onClose}
//                 aria-labelledby="access-denied-modal-title"
//                 aria-describedby="access-denied-modal-description"
//             >
//                 <Box sx={style}>
//                     <Typography id="access-denied-modal-title" variant="h6" component="h2" gutterBottom>
//                         <CalendarTodayIcon sx={{ mr: 1, verticalAlign: 'middle' }} />
//                         Access Denied
//                     </Typography>
                    
//                     <Alert severity="warning" sx={{ mb: 2 }}>
//                         <Stack direction="row" alignItems="center" spacing={1}>
//                             <ListIcon fontSize="small" />
//                             <Typography variant="body2">
//                                 Training Calendar is only accessible to authorized roles.
//                                 Your role: <strong>{type}</strong>
//                             </Typography>
//                         </Stack>
//                     </Alert>

//                     <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end' }}>
//                         <Button onClick={onClose} variant="contained">
//                             Close
//                         </Button>
//                     </Box>
//                 </Box>
//             </Modal>
//         );
//     }

//     return (
//         <Modal
//             open={isOpen}
//             onClose={onClose}
//             aria-labelledby="training-details-modal-title"
//             aria-describedby="training-details-modal-description"
//         >
//             <Box sx={style}>
//                 <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
//                     <Typography id="training-details-modal-title" variant="h6" component="h2">
//                         <CalendarTodayIcon sx={{ mr: 1, verticalAlign: 'middle' }} />
//                         Trainings on Selected Date
//                         <Chip 
//                             label={type} 
//                             size="small" 
//                             color="primary"
//                             sx={{ ml: 2 }}
//                         />
//                     </Typography>
                    
//                     <Tooltip title={use24HourFormat ? "Switch to 12-hour format" : "Switch to 24-hour format"}>
//                         <Button 
//                             size="small" 
//                             variant="outlined" 
//                             onClick={toggleTimeFormat}
//                             startIcon={<TwentyFourMpIcon />}
//                             sx={{ textTransform: 'none' }}
//                         >
//                             {use24HourFormat ? "24h Format" : "12h Format"}
//                         </Button>
//                     </Tooltip>
//                 </Box>
                
//                 <Alert severity="info" sx={{ mb: 2 }}>
//                     <Stack direction="row" alignItems="center" spacing={1}>
//                         <ListIcon fontSize="small" />
//                         <Typography variant="body2">
//                             {type === "Tata Depot Manager" && userInfo?.depot && (
//                                 <>Showing trainings for depot: <strong>{userInfo.depot}</strong></>
//                             )}
//                             {type === "Tata Trainer" && (
//                                 <>Showing trainings assigned to: <strong>{userInfo.userName || 'you'}</strong></>
//                             )}
//                             {["Tata Project Manager", "Admin", "Super Admin"].includes(type) && (
//                                 <>Showing all trainings</>
//                             )}
//                         </Typography>
//                     </Stack>
//                 </Alert>

//                 <Box sx={{ mb: 3, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//                     <Button 
//                         variant="outlined" 
//                         color="primary" 
//                         startIcon={<ListIcon />}
//                         onClick={handleViewAllBatches}
//                         size="small"
//                     >
//                         View All Batches
//                     </Button>
                    
//                     <Typography variant="caption" color="text.secondary">
//                         {filteredTrainings?.length || 0} training(s) found
//                         {filteredTrainings?.length !== trainings?.length && (
//                             <span style={{ color: '#f44336', marginLeft: '8px' }}>
//                                 ({trainings?.length - filteredTrainings?.length} filtered out based on your access)
//                             </span>
//                         )}
//                     </Typography>
//                 </Box>

//                 {filteredTrainings && filteredTrainings.length > 0 ? (
//                     <Box sx={{ width: '100%' }}>
//                         {filteredTrainings.map((training, index) => {
//                             if (!training) return null;
                            
//                             const trainingTypeColor = getTrainingTypeColor(training.type);
//                             const assessmentTypeColor = getAssessmentTypeColor(training.technicalAssessmentType);
//                             const trainerName = getTrainerName(training.trainerId);
//                             const timeInfo = getTrainingTimeInfo(training);
//                             const totalHours = getTotalTrainingHours(training);
//                             const trainingDaysInfo = getTrainingDaysInfo(training);
//                             const scheduleInfo = getTrainingScheduleInfo(training);
//                             const isPastDate = training.isPastDate || isDateInPast(training.trainingStartDate);
//                             const isTechnicalTraining = training.isTechnicalTraining || training.type?.includes('Technical');
//                             const originalType = extractOriginalType(training.type);
//                             const daysFromType = extractDaysFromType(training.type);
//                             const dateRange = getDateRangeString(training.trainingStartDate, training.trainingEndDate);
                            
//                             return (
//                                 <React.Fragment key={training.id || index}>
//                                     <Card 
//                                         sx={{ 
//                                             mb: 2, 
//                                             borderLeft: `4px solid ${trainingTypeColor}`,
//                                             '&:hover': {
//                                                 boxShadow: 4
//                                             }
//                                         }}
//                                     >
//                                         <CardContent>
//                                             <Grid container spacing={2}>
//                                                 <Grid item xs={12}>
//                                                     <Stack direction="row" justifyContent="space-between" alignItems="flex-start">
//                                                         <Box sx={{ flex: 1 }}>
//                                                             <Typography variant="h6" fontWeight="bold" gutterBottom>
//                                                                 {training.name || 'Unnamed Training'}
//                                                                 {isPastDate && (
//                                                                     <Tooltip title="This training has past dates">
//                                                                         <WarningIcon 
//                                                                             sx={{ 
//                                                                                 ml: 1, 
//                                                                                 color: 'warning.main', 
//                                                                                 fontSize: '1rem',
//                                                                                 verticalAlign: 'middle'
//                                                                             }} 
//                                                                         />
//                                                                     </Tooltip>
//                                                                 )}
//                                                             </Typography>
//                                                             <Stack direction="row" spacing={1} alignItems="center" sx={{ mt: 0.5, flexWrap: 'wrap', gap: 0.5 }}>
//                                                                 <Chip 
//                                                                     label={originalType || training.type} 
//                                                                     size="small" 
//                                                                     sx={{ 
//                                                                         backgroundColor: trainingTypeColor,
//                                                                         color: 'white',
//                                                                     }} 
//                                                                 />
//                                                                 {dateRange && (
//                                                                     <Chip 
//                                                                         label={`📅 ${dateRange}`}
//                                                                         size="small"
//                                                                         color="primary"
//                                                                         variant="outlined"
//                                                                     />
//                                                                 )}
//                                                                 {totalHours > 0 && (
//                                                                     <Chip 
//                                                                         label={`${totalHours} total hrs`}
//                                                                         size="small"
//                                                                         color="secondary"
//                                                                         variant="outlined"
//                                                                     />
//                                                                 )}
//                                                                 {isTechnicalTraining && training.technicalAssessmentType && (
//                                                                     <Chip 
//                                                                         label={`${training.technicalAssessmentType} Assessment`}
//                                                                         size="small"
//                                                                         sx={{ 
//                                                                             backgroundColor: assessmentTypeColor,
//                                                                             color: 'white'
//                                                                         }}
//                                                                         icon={<WorkspacePremiumIcon sx={{ fontSize: '0.9rem' }} />}
//                                                                     />
//                                                                 )}
//                                                                 {training.batchId && (
//                                                                     <Chip 
//                                                                         label="Batch Created"
//                                                                         size="small"
//                                                                         color="success"
//                                                                     />
//                                                                 )}
//                                                                 {training.allowPreviousDates === false && (
//                                                                     <Chip 
//                                                                         label="No Past Dates"
//                                                                         size="small"
//                                                                         color="warning"
//                                                                         variant="outlined"
//                                                                     />
//                                                                 )}
//                                                                 {/* Display Training Mode from backend */}
//                                                                 {training.trainingMode ? (
//                                                                     <Chip 
//                                                                         label={`📋 ${training.trainingMode}`}
//                                                                         size="small"
//                                                                         color="info"
//                                                                         variant="outlined"
//                                                                     />
//                                                                 ) : (
//                                                                     <Chip 
//                                                                         label="📋 N/A"
//                                                                         size="small"
//                                                                         color="default"
//                                                                         variant="outlined"
//                                                                     />
//                                                                 )}
//                                                                 {/* Display Batch Plan from backend */}
//                                                                 {training.batchPlan ? (
//                                                                     <Chip 
//                                                                         label={`📊 Plan: ${training.batchPlan}`}
//                                                                         size="small"
//                                                                         color="secondary"
//                                                                         variant="outlined"
//                                                                     />
//                                                                 ) : (
//                                                                     <Chip 
//                                                                         label="📊 Plan: N/A"
//                                                                         size="small"
//                                                                         color="default"
//                                                                         variant="outlined"
//                                                                     />
//                                                                 )}
//                                                             </Stack>
//                                                         </Box>
//                                                         <Stack direction="row" spacing={0.5}>
//                                                             {canGenerateBatch() && !training.batchId && (
//                                                                 <Tooltip title="Generate Batch">
//                                                                     <IconButton
//                                                                         size="small"
//                                                                         onClick={() => handleGenerateBatchForTraining(training)}
//                                                                         sx={{ 
//                                                                             backgroundColor: '#4caf50',
//                                                                             color: 'white',
//                                                                             '&:hover': {
//                                                                                 backgroundColor: '#388e3c'
//                                                                             }
//                                                                         }}
//                                                                     >
//                                                                         <OpenInNewIcon fontSize="small" />
//                                                                     </IconButton>
//                                                                 </Tooltip>
//                                                             )}
//                                                             {training.batchId && (
//                                                                 <Tooltip title="Open Batch">
//                                                                     <IconButton
//                                                                         size="small"
//                                                                         onClick={() => handleNavigateToBatch(training)}
//                                                                         sx={{ 
//                                                                             backgroundColor: '#2196f3',
//                                                                             color: 'white',
//                                                                             '&:hover': {
//                                                                                 backgroundColor: '#1976d2'
//                                                                             }
//                                                                         }}
//                                                                     >
//                                                                         <OpenInNewIcon fontSize="small" />
//                                                                     </IconButton>
//                                                                 </Tooltip>
//                                                             )}
//                                                             {canDeleteTraining() && (
//                                                                 <Tooltip title="Delete Training">
//                                                                     <IconButton
//                                                                         size="small"
//                                                                         onClick={() => onDeleteTraining && onDeleteTraining(training.id)}
//                                                                         color="error"
//                                                                     >
//                                                                         <DeleteIcon fontSize="small" />
//                                                                     </IconButton>
//                                                                 </Tooltip>
//                                                             )}
//                                                         </Stack>
//                                                     </Stack>
//                                                 </Grid>

//                                                 <Grid item xs={12}>
//                                                     <Stack spacing={2}>
//                                                         {/* Basic Information */}
//                                                         <Paper elevation={0} sx={{ p: 2, bgcolor: '#f8f9fa', borderRadius: 2 }}>
//                                                             <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
//                                                                 Basic Information
//                                                             </Typography>
//                                                             <Grid container spacing={2}>
//                                                                 <Grid item xs={6}>
//                                                                     <Stack direction="row" spacing={1} alignItems="center">
//                                                                         <LocationOnIcon fontSize="small" color="action" />
//                                                                         <Box>
//                                                                             <Typography variant="caption" color="text.secondary">
//                                                                                 Location
//                                                                             </Typography>
//                                                                             <Typography variant="body2" fontWeight="medium">
//                                                                                 {training.depot || 'N/A'}, {training.state || 'N/A'}
//                                                                             </Typography>
//                                                                         </Box>
//                                                                     </Stack>
//                                                                 </Grid>
//                                                                 <Grid item xs={6}>
//                                                                     <Stack direction="row" spacing={1} alignItems="center">
//                                                                         <PersonIcon fontSize="small" color="action" />
//                                                                         <Box>
//                                                                             <Typography variant="caption" color="text.secondary">
//                                                                                 Trainer
//                                                                             </Typography>
//                                                                             <Typography variant="body2" fontWeight="medium">
//                                                                                 {loadingTrainers ? (
//                                                                                     <CircularProgress size={12} sx={{ ml: 1 }} />
//                                                                                 ) : (
//                                                                                     trainerName
//                                                                                 )}
//                                                                             </Typography>
//                                                                             {training.trainerEmail && (
//                                                                                 <Typography variant="caption" color="text.secondary" display="block">
//                                                                                     {training.trainerEmail}
//                                                                                 </Typography>
//                                                                             )}
//                                                                             {training.trainerPhone && (
//                                                                                 <Typography variant="caption" color="text.secondary" display="block">
//                                                                                     Phone: {training.trainerPhone}
//                                                                                 </Typography>
//                                                                             )}
//                                                                         </Box>
//                                                                     </Stack>
//                                                                 </Grid>
//                                                             </Grid>
//                                                         </Paper>

//                                                         {/* Schedule Information */}
//                                                         <Paper elevation={0} sx={{ p: 2, bgcolor: '#f8f9fa', borderRadius: 2 }}>
//                                                             <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
//                                                                 Schedule Information
//                                                             </Typography>
//                                                             <Grid container spacing={2}>
//                                                                 <Grid item xs={6}>
//                                                                     <Stack spacing={1}>
//                                                                         <Stack direction="row" spacing={1} alignItems="center">
//                                                                             <TodayIcon fontSize="small" color="action" />
//                                                                             <Box>
//                                                                                 <Typography variant="caption" color="text.secondary">
//                                                                                     Start Date
//                                                                                 </Typography>
//                                                                                 <Typography variant="body2" fontWeight="medium">
//                                                                                     {formatDate(training.trainingStartDate)}
//                                                                                     {isPastDate && (
//                                                                                         <Typography variant="caption" color="warning.main" display="block">
//                                                                                             ⚠️ Past date
//                                                                                         </Typography>
//                                                                                     )}
//                                                                                 </Typography>
//                                                                             </Box>
//                                                                         </Stack>
//                                                                         <Stack direction="row" spacing={1} alignItems="center">
//                                                                             <EventRepeatIcon fontSize="small" color="action" />
//                                                                             <Box>
//                                                                                 <Typography variant="caption" color="text.secondary">
//                                                                                     Training Days
//                                                                                 </Typography>
//                                                                                 <Typography variant="body2" fontWeight="medium">
//                                                                                     {trainingDaysInfo.trainingDaysText}
//                                                                                 </Typography>
//                                                                             </Box>
//                                                                         </Stack>
//                                                                     </Stack>
//                                                                 </Grid>
//                                                                 <Grid item xs={6}>
//                                                                     <Stack spacing={1}>
//                                                                         <Stack direction="row" spacing={1} alignItems="center">
//                                                                             <CalendarMonthIcon fontSize="small" color="action" />
//                                                                             <Box>
//                                                                                 <Typography variant="caption" color="text.secondary">
//                                                                                     End Date
//                                                                                 </Typography>
//                                                                                 <Typography variant="body2" fontWeight="medium">
//                                                                                     {formatDate(training.trainingEndDate)}
//                                                                                 </Typography>
//                                                                             </Box>
//                                                                         </Stack>
//                                                                         <Stack direction="row" spacing={1} alignItems="center">
//                                                                             <EventNoteIcon fontSize="small" color="action" />
//                                                                             <Box>
//                                                                                 <Typography variant="caption" color="text.secondary">
//                                                                                     Date Range
//                                                                                 </Typography>
//                                                                                 <Typography variant="body2" fontWeight="medium" color="primary">
//                                                                                     {dateRange || 'N/A'}
//                                                                                 </Typography>
//                                                                             </Box>
//                                                                         </Stack>
//                                                                     </Stack>
//                                                                 </Grid>
//                                                             </Grid>
//                                                         </Paper>

//                                                         {/* Time Information */}
//                                                         <Paper elevation={0} sx={{ p: 2, bgcolor: '#f8f9fa', borderRadius: 2 }}>
//                                                             <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
//                                                                 Time Information
//                                                             </Typography>
//                                                             <Grid container spacing={2}>
//                                                                 <Grid item xs={6}>
//                                                                     <Stack direction="row" spacing={1} alignItems="center">
//                                                                         <ScheduleIcon fontSize="small" color="action" />
//                                                                         <Box>
//                                                                             <Typography variant="caption" color="text.secondary">
//                                                                                 Daily Timing
//                                                                             </Typography>
//                                                                             <Typography variant="body2" fontWeight="medium">
//                                                                                 {timeInfo.timeDisplay}
//                                                                                 {timeInfo.source === 'type' && (
//                                                                                     <Typography variant="caption" color="info.main" display="block">
//                                                                                         (Extracted from type field)
//                                                                                     </Typography>
//                                                                                 )}
//                                                                             </Typography>
//                                                                         </Box>
//                                                                     </Stack>
//                                                                 </Grid>
//                                                                 <Grid item xs={6}>
//                                                                     <Stack direction="row" spacing={1} alignItems="center">
//                                                                         <AccessTimeIcon fontSize="small" color="action" />
//                                                                         <Box>
//                                                                             <Typography variant="caption" color="text.secondary">
//                                                                                 Total Hours
//                                                                             </Typography>
//                                                                             <Typography variant="body2" fontWeight="medium">
//                                                                                 {totalHours} hours
//                                                                             </Typography>
//                                                                         </Box>
//                                                                     </Stack>
//                                                                 </Grid>
//                                                                 <Grid item xs={12}>
//                                                                     <Box sx={{ mt: 1, p: 1, bgcolor: '#e8f4fd', borderRadius: 1 }}>
//                                                                         <Typography variant="caption" color="text.secondary">
//                                                                             <strong>Complete Type Field:</strong> {training.type || 'N/A'}
//                                                                         </Typography>
//                                                                     </Box>
//                                                                 </Grid>
//                                                             </Grid>
//                                                         </Paper>

//                                                         {/* Training Mode & Batch Plan Information - Fetched from backend */}
//                                                         <Paper elevation={0} sx={{ p: 2, bgcolor: '#f8f9fa', borderRadius: 2 }}>
//                                                             <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
//                                                                 Training Configuration
//                                                             </Typography>
//                                                             <Grid container spacing={2}>
//                                                                 <Grid item xs={6}>
//                                                                     <Stack direction="row" spacing={1} alignItems="center">
//                                                                         <PersonIcon fontSize="small" color="action" />
//                                                                         <Box>
//                                                                             <Typography variant="caption" color="text.secondary">
//                                                                                 Training Mode
//                                                                             </Typography>
//                                                                             <Typography variant="body2" fontWeight="medium">
//                                                                                 {training.trainingMode || 'N/A'}
//                                                                             </Typography>
//                                                                         </Box>
//                                                                     </Stack>
//                                                                 </Grid>
//                                                                 <Grid item xs={6}>
//                                                                     <Stack direction="row" spacing={1} alignItems="center">
//                                                                         <WorkspacePremiumIcon fontSize="small" color="action" />
//                                                                         <Box>
//                                                                             <Typography variant="caption" color="text.secondary">
//                                                                                 Batch Plan
//                                                                             </Typography>
//                                                                             <Typography variant="body2" fontWeight="medium">
//                                                                                 {training.batchPlan || 'N/A'}
//                                                                             </Typography>
//                                                                         </Box>
//                                                                     </Stack>
//                                                                 </Grid>
//                                                                 {training.courseTitle && (
//                                                                     <Grid item xs={12}>
//                                                                         <Stack direction="row" spacing={1} alignItems="center">
//                                                                             <ListIcon fontSize="small" color="action" />
//                                                                             <Box>
//                                                                                 <Typography variant="caption" color="text.secondary">
//                                                                                     Course
//                                                                                 </Typography>
//                                                                                 <Typography variant="body2" fontWeight="medium">
//                                                                                     {training.courseTitle}
//                                                                                 </Typography>
//                                                                             </Box>
//                                                                         </Stack>
//                                                                     </Grid>
//                                                                 )}
//                                                             </Grid>
//                                                         </Paper>

//                                                         {/* Training Schedule Details */}
//                                                         {scheduleInfo.scheduleDetails.length > 0 && (
//                                                             <Paper elevation={0} sx={{ p: 2, bgcolor: '#f8f9fa', borderRadius: 2 }}>
//                                                                 <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
//                                                                     Training Schedule ({scheduleInfo.scheduleDetails.length} days)
//                                                                 </Typography>
//                                                                 <Box sx={{ mt: 1, maxHeight: '150px', overflowY: 'auto', p: 1 }}>
//                                                                     <Grid container spacing={1}>
//                                                                         {scheduleInfo.scheduleDetails.map((day, idx) => {
//                                                                             const isPast = isDateInPast(format(day.date, 'yyyy-MM-dd'));
//                                                                             const dayStartTimeFormatted = formatTimeDisplay(day.startTime);
//                                                                             const dayEndTimeFormatted = formatTimeDisplay(day.endTime);
//                                                                             return (
//                                                                                 <Grid item xs={6} sm={4} key={idx}>
//                                                                                     <Paper 
//                                                                                         elevation={0}
//                                                                                         sx={{ 
//                                                                                             p: 1,
//                                                                                             bgcolor: isPast ? '#fff3cd' : '#d4edda',
//                                                                                             border: `1px solid ${isPast ? '#ffeaa7' : '#c3e6cb'}`,
//                                                                                             borderRadius: 1
//                                                                                         }}
//                                                                                     >
//                                                                                         <Typography variant="caption" fontWeight="medium">
//                                                                                             {formatDateShort(day.date)} ({day.dayOfWeek.substring(0, 3)})
//                                                                                             {isPast && ' ⚠️'}
//                                                                                         </Typography>
//                                                                                         <Typography variant="caption" display="block">
//                                                                                             {dayStartTimeFormatted} - {dayEndTimeFormatted}
//                                                                                         </Typography>
//                                                                                         {day.duration > 0 && (
//                                                                                             <Typography variant="caption" display="block" color="text.secondary">
//                                                                                                 {day.duration} hours
//                                                                                             </Typography>
//                                                                                         )}
//                                                                                     </Paper>
//                                                                                 </Grid>
//                                                                             );
//                                                                         })}
//                                                                     </Grid>
//                                                                 </Box>
//                                                             </Paper>
//                                                         )}
//                                                     </Stack>
//                                                 </Grid>

//                                                 {training.batchId && (
//                                                     <Grid item xs={12}>
//                                                         <Button
//                                                             variant="contained"
//                                                             color="primary"
//                                                             fullWidth
//                                                             size="small"
//                                                             onClick={() => handleNavigateToBatch(training)}
//                                                             startIcon={<OpenInNewIcon />}
//                                                         >
//                                                             Open Batch ({training.batchName || `Batch ${training.batchId}`})
//                                                         </Button>
//                                                     </Grid>
//                                                 )}

//                                                 {!training.batchId && canGenerateBatch() && (
//                                                     <Grid item xs={12}>
//                                                         <Button
//                                                             variant="outlined"
//                                                             color="success"
//                                                             fullWidth
//                                                             size="small"
//                                                             onClick={() => handleGenerateBatchForTraining(training)}
//                                                             startIcon={<OpenInNewIcon />}
//                                                         >
//                                                             Generate Batch for this Training
//                                                         </Button>
//                                                     </Grid>
//                                                 )}
//                                             </Grid>
//                                         </CardContent>
//                                     </Card>
//                                     {index < filteredTrainings.length - 1 && <Divider sx={{ my: 2 }} />}
//                                 </React.Fragment>
//                             );
//                         })}
//                     </Box>
//                 ) : (
//                     <Box sx={{ textAlign: 'center', py: 4 }}>
//                         <Typography variant="body1" color="text.secondary">
//                             No trainings found for the selected date
//                             {trainings?.length > 0 && filteredTrainings?.length === 0 && (
//                                 <Typography variant="caption" display="block" color="error" sx={{ mt: 1 }}>
//                                     (You don't have access to view these trainings)
//                                 </Typography>
//                             )}
//                         </Typography>
//                     </Box>
//                 )}

//                 <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end' }}>
//                     <Button onClick={onClose} variant="contained">
//                         Close
//                     </Button>
//                 </Box>
//             </Box>
//         </Modal>
//     );
// };

// export default TrainingDetailsModal;








import React, { useState, useEffect } from 'react';
import {
    Modal, Box, Typography, Button, TextField, Grid, FormControl, InputLabel,
    Select, MenuItem, Alert, Chip, Stack, Divider, IconButton, Tooltip,
    Paper, CircularProgress, InputAdornment, FormHelperText,
    Card, CardContent
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import CloseIcon from '@mui/icons-material/Close';
import InfoIcon from '@mui/icons-material/Info';
import LockIcon from '@mui/icons-material/Lock';
import PersonIcon from '@mui/icons-material/Person';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import ListIcon from '@mui/icons-material/List';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import ScheduleIcon from '@mui/icons-material/Schedule';
import EventNoteIcon from '@mui/icons-material/EventNote';
import EventRepeatIcon from '@mui/icons-material/EventRepeat';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import TodayIcon from '@mui/icons-material/Today';
import WarningIcon from '@mui/icons-material/Warning';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import TwentyFourMpIcon from '@mui/icons-material/TwentyFourMp';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import PauseCircleFilledIcon from '@mui/icons-material/PauseCircleFilled';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import PlayCircleFilledIcon from '@mui/icons-material/PlayCircleFilled';
import { format, parseISO, isBefore, isToday, startOfDay } from 'date-fns';
import { useNavigate } from 'react-router-dom';
import { fetchAllTrainers } from 'helpers/user_helper';
import { toast } from 'react-toastify';

// ==================== STATUS OPTIONS ====================
const STATUS_OPTIONS = [
    { value: 'Active', label: 'Active', color: '#4caf50', bgColor: '#e8f5e9', icon: <PlayCircleFilledIcon />, description: 'Training is active and ongoing' },
    { value: 'Cancelled', label: 'Cancelled', color: '#f44336', bgColor: '#ffebee', icon: <CancelIcon />, description: 'Training has been cancelled' },
    { value: 'Postponed', label: 'Postponed', color: '#ff9800', bgColor: '#fff3e0', icon: <PauseCircleFilledIcon />, description: 'Training has been postponed' },
    { value: 'Completed', label: 'Completed', color: '#2196f3', bgColor: '#e3f2fd', icon: <CheckCircleIcon />, description: 'Training has been completed' },
    { value: 'Other', label: 'Other (Custom Reason)', color: '#9c27b0', bgColor: '#f3e5f5', icon: <HelpOutlineIcon />, description: 'Specify a custom reason' }
];

const style = {
    position: 'absolute', top: '50%', left: '50%',
    transform: 'translate(-50%, -50%)', width: 700, maxWidth: '95vw',
    bgcolor: 'background.paper', border: '2px solid #000', boxShadow: 24,
    p: 3, maxHeight: '90vh', overflowY: 'auto',
};

const editStyle = {
    position: 'absolute', top: '50%', left: '50%',
    transform: 'translate(-50%, -50%)', width: 800, maxWidth: '95vw',
    bgcolor: 'background.paper', border: '2px solid #1976d2', boxShadow: 24,
    borderRadius: 2, p: 3, maxHeight: '90vh', overflowY: 'auto',
};

const trainingTypes = [
    { id: 1, name: "Safety", color: "#f44336" },
    { id: 2, name: "IT", color: "#2196f3" },
    { id: 3, name: "Technical", color: "#4caf50" },
    { id: 4, name: "Driver", color: "#ff9800" }
];

const assessmentTypeData = [
    { id: 'bronze', name: 'Bronze', color: '#CD7F32' },
    { id: 'silver', name: 'Silver', color: '#C0C0C0' },
    { id: 'gold', name: 'Gold', color: '#FFD700' }
];

// ==================== HELPERS (Shared) ====================
const isDateInPast = (dateString) => {
    if (!dateString) return false;
    try {
        const date = parseISO(dateString);
        const today = startOfDay(new Date());
        return isBefore(date, today) && !isToday(date);
    } catch { return false; }
};

const convertTo12HourFormat = (time24) => {
    if (!time24) return '';
    if (time24.includes('AM') || time24.includes('PM')) return time24;
    const match = time24.match(/(\d{1,2}):(\d{2})/);
    if (!match) return time24;
    let hour = parseInt(match[1]);
    const minute = match[2];
    const ampm = hour >= 12 ? 'PM' : 'AM';
    hour = hour % 12 || 12;
    return `${hour}:${minute} ${ampm}`;
};

const convertTo24HourFormat = (time12) => {
    if (!time12) return '';
    if (time12.match(/^([01]?[0-9]|2[0-3]):[0-5][0-9]$/)) return time12;
    const match = time12.match(/(\d{1,2}):(\d{2})\s*(AM|PM)/i);
    if (!match) return time12;
    let hour = parseInt(match[1]);
    const minute = match[2];
    const ampm = match[3].toUpperCase();
    if (ampm === 'PM' && hour !== 12) hour += 12;
    if (ampm === 'AM' && hour === 12) hour = 0;
    return `${hour.toString().padStart(2, '0')}:${minute}`;
};

const extractTimeFromType = (typeString) => {
    if (!typeString) return null;
    const timePattern = /(\d{1,2}:\d{2}\s*(?:AM|PM|am|pm)?)\s*-\s*(\d{1,2}:\d{2}\s*(?:AM|PM|am|pm)?)/gi;
    const match = timePattern.exec(typeString);
    if (match && match.length >= 3) return { startTime: match[1], endTime: match[2] };
    return null;
};

const extractDaysFromType = (typeString) => {
    if (!typeString) return null;
    const daysPattern = /-\s*(\d+)\s*(?:Day|Days|day|days)/i;
    const match = daysPattern.exec(typeString);
    return match && match.length >= 2 ? parseInt(match[1]) : null;
};

const extractOriginalType = (typeString) => {
    if (!typeString) return typeString;
    const timePattern = /-\s*\d{1,2}:\d{2}\s*(?:AM|PM|am|pm)?\s*-\s*\d{1,2}:\d{2}\s*(?:AM|PM|am|pm)?$/i;
    const typeWithoutTime = typeString.replace(timePattern, '').trim();
    return typeWithoutTime.replace(/-\s*$/, '').trim();
};

const getDateRangeString = (startDate, endDate) => {
    if (!startDate || !endDate) return '';
    try {
        const start = new Date(startDate);
        const end = new Date(endDate);
        const startDay = format(start, 'd');
        const endDay = format(end, 'd');
        const startMonth = format(start, 'MMM');
        const endMonth = format(end, 'MMM');
        if (startMonth === endMonth) return `${startDay}-${endDay} ${startMonth}`;
        return `${startDay} ${startMonth} - ${endDay} ${endMonth}`;
    } catch { return ''; }
};

const getStatusInfo = (status) => {
    if (!status) return { label: 'N/A', color: '#9e9e9e', bgColor: '#f5f5f5', icon: '⚪' };
    const s = status.toLowerCase();
    if (s.includes('active')) return { label: 'Active', color: '#4caf50', bgColor: '#e8f5e9', icon: '🟢' };
    if (s.includes('cancel')) return { label: 'Cancelled', color: '#f44336', bgColor: '#ffebee', icon: '🔴' };
    if (s.includes('postpon')) return { label: 'Postponed', color: '#ff9800', bgColor: '#fff3e0', icon: '🟡' };
    if (s.includes('complet')) return { label: 'Completed', color: '#2196f3', bgColor: '#e3f2fd', icon: '🔵' };
    return { label: status, color: '#9c27b0', bgColor: '#f3e5f5', icon: '🟣' };
};

// ==================== UPDATE FORM (TOP-LEVEL COMPONENT — NO BLINK) ====================
const UpdateTrainingForm = ({
    isUpdateModalOpen,
    selectedTrainingForUpdate,
    handleCloseUpdateModal,
    handleUpdateTraining,
    getTrainerName,
    canUpdateTraining
}) => {
    const [formData, setFormData] = useState({
        id: null, status: 'Active', customReason: '',
        depot: '', state: '', trainingStartDate: '',
        trainingEndDate: '', trainingMode: '', batchPlan: ''
    });
    const [formErrors, setFormErrors] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);

    const training = selectedTrainingForUpdate;

    useEffect(() => {
        if (training && isUpdateModalOpen) {
            let statusValue = 'Active';
            let customReason = '';
            if (training.status) {
                const s = training.status.toLowerCase();
                if (s.includes('active')) statusValue = 'Active';
                else if (s.includes('cancel')) statusValue = 'Cancelled';
                else if (s.includes('postpon')) statusValue = 'Postponed';
                else if (s.includes('complet')) statusValue = 'Completed';
                else {
                    statusValue = 'Other';
                    customReason = training.status.replace(/^Other:\s*/i, '');
                }
            }
            setFormData({
                id: training.id,
                status: statusValue,
                customReason: customReason,
                depot: training.depot || '',
                state: training.state || '',
                trainingStartDate: training.trainingStartDate ? format(new Date(training.trainingStartDate), 'yyyy-MM-dd') : '',
                trainingEndDate: training.trainingEndDate ? format(new Date(training.trainingEndDate), 'yyyy-MM-dd') : '',
                trainingMode: training.trainingMode || '',
                batchPlan: training.batchPlan || ''
            });
            setFormErrors({});
        }
    }, [training, isUpdateModalOpen]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev, [name]: value,
            ...(name === 'status' && value !== 'Other' ? { customReason: '' } : {})
        }));
        if (formErrors[name]) setFormErrors(prev => ({ ...prev, [name]: '' }));
    };

    const validateForm = () => {
        const errors = {};
        if (!formData.status) errors.status = 'Status is required';
        if (formData.status === 'Other' && !formData.customReason?.trim()) errors.customReason = 'Please specify a custom reason';
        if (formData.trainingStartDate && formData.trainingEndDate) {
            if (new Date(formData.trainingStartDate) > new Date(formData.trainingEndDate)) {
                errors.trainingEndDate = 'End date cannot be before start date';
            }
        }
        setFormErrors(errors);
        return Object.keys(errors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) {
            toast.error('Please fix the errors before submitting');
            return;
        }
        if (!canUpdateTraining()) {
            toast.error('You do not have permission to update trainings');
            return;
        }
        try {
            setIsSubmitting(true);
            const payload = {
                id: formData.id,
                status: formData.status === 'Other' ? `Other: ${formData.customReason.trim()}` : formData.status,
                depot: formData.depot,
                state: formData.state,
                trainingStartDate: formData.trainingStartDate ? new Date(formData.trainingStartDate).toISOString() : undefined,
                trainingEndDate: formData.trainingEndDate ? new Date(formData.trainingEndDate).toISOString() : undefined,
                trainingMode: formData.trainingMode,
                batchPlan: formData.batchPlan
            };
            Object.keys(payload).forEach(k => payload[k] === undefined && delete payload[k]);
            await handleUpdateTraining(payload);
            toast.success('Training updated successfully!');
        } catch (error) {
            console.error('Error updating training:', error);
            toast.error(error.message || 'Failed to update training');
        } finally {
            setIsSubmitting(false);
        }
    };

    const selectedStatus = STATUS_OPTIONS.find(s => s.value === formData.status);

    if (!training) return null;

    return (
        <Modal open={isUpdateModalOpen} onClose={handleCloseUpdateModal}>
            <Box sx={editStyle}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                    <Typography variant="h5" fontWeight="bold" color="primary">
                        <EditIcon sx={{ mr: 1, verticalAlign: 'middle' }} />
                        Update Training
                    </Typography>
                    <IconButton onClick={handleCloseUpdateModal} disabled={isSubmitting}>
                        <CloseIcon />
                    </IconButton>
                </Box>

                <Divider sx={{ mb: 2 }} />

                <Alert severity="info" icon={<LockIcon />} sx={{ mb: 2 }}>
                    <Typography variant="body2" fontWeight="bold">Locked Fields (Cannot be changed):</Typography>
                    <Typography variant="caption" display="block">• Training Name: <strong>{training.name}</strong></Typography>
                    <Typography variant="caption" display="block">• Department/Type: <strong>{training.type}</strong></Typography>
                    <Typography variant="caption" display="block">• Trainer: <strong>{getTrainerName(training.trainerId)}</strong></Typography>
                </Alert>

                <form onSubmit={handleSubmit}>
                    <Grid container spacing={2}>
                        {/* STATUS SECTION */}
                        <Grid item xs={12}>
                            <Paper elevation={2} sx={{ p: 2, bgcolor: '#f8f9fa', borderRadius: 2 }}>
                                <Typography variant="subtitle1" fontWeight="bold" gutterBottom>Training Status</Typography>
                                <FormControl fullWidth error={!!formErrors.status} required>
                                    <InputLabel>Status</InputLabel>
                                    <Select name="status" value={formData.status} label="Status" onChange={handleChange} disabled={isSubmitting}>
                                        {STATUS_OPTIONS.map((option) => (
                                            <MenuItem key={option.value} value={option.value} sx={{ '&:hover': { bgcolor: option.bgColor } }}>
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, width: '100%' }}>
                                                    <Box sx={{ color: option.color, display: 'flex', alignItems: 'center' }}>{option.icon}</Box>
                                                    <Box sx={{ flex: 1 }}>
                                                        <Typography variant="body2" fontWeight="bold" sx={{ color: option.color }}>{option.label}</Typography>
                                                        <Typography variant="caption" color="text.secondary">{option.description}</Typography>
                                                    </Box>
                                                </Box>
                                            </MenuItem>
                                        ))}
                                    </Select>
                                    {formErrors.status && <FormHelperText error>{formErrors.status}</FormHelperText>}
                                </FormControl>

                                {selectedStatus && (
                                    <Box sx={{ mt: 2, p: 1.5, bgcolor: selectedStatus.bgColor, borderLeft: `4px solid ${selectedStatus.color}`, borderRadius: 1, display: 'flex', alignItems: 'center', gap: 1 }}>
                                        <Box sx={{ color: selectedStatus.color }}>{selectedStatus.icon}</Box>
                                        <Typography variant="body2" sx={{ color: selectedStatus.color }}>
                                            <strong>Current Status:</strong> {selectedStatus.label}
                                        </Typography>
                                    </Box>
                                )}

                                {formData.status === 'Other' && (
                                    <TextField
                                        fullWidth label="Custom Reason" name="customReason" value={formData.customReason}
                                        onChange={handleChange} multiline rows={3} required
                                        error={!!formErrors.customReason}
                                        helperText={formErrors.customReason || "Please specify the reason"}
                                        disabled={isSubmitting}
                                        placeholder="E.g., Trainer unavailable, etc."
                                        sx={{ mt: 2 }}
                                        InputProps={{ startAdornment: (<InputAdornment position="start"><InfoIcon color="action" /></InputAdornment>) }}
                                    />
                                )}
                            </Paper>
                        </Grid>

                        <Grid item xs={12}>
                            <Typography variant="subtitle1" fontWeight="bold" sx={{ mt: 1 }}>Editable Details</Typography>
                        </Grid>

                        <Grid item xs={6}>
                            <TextField fullWidth label="Depot" name="depot" value={formData.depot} onChange={handleChange} disabled={isSubmitting} />
                        </Grid>

                        <Grid item xs={6}>
                            <TextField fullWidth label="State" name="state" value={formData.state} onChange={handleChange} disabled={isSubmitting} />
                        </Grid>

                        <Grid item xs={6}>
                            <FormControl fullWidth>
                                <InputLabel>Training Mode</InputLabel>
                                <Select name="trainingMode" value={formData.trainingMode} label="Training Mode" onChange={handleChange} disabled={isSubmitting}>
                                    <MenuItem value=""><em>None</em></MenuItem>
                                    <MenuItem value="Internal">Internal</MenuItem>
                                    <MenuItem value="External">External</MenuItem>
                                    <MenuItem value="Online">Online</MenuItem>
                                    <MenuItem value="Offline">Offline</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>

                        <Grid item xs={6}>
                            <TextField fullWidth label="Batch Plan" name="batchPlan" type="number" value={formData.batchPlan}
                                onChange={handleChange} disabled={isSubmitting} inputProps={{ min: 0, step: 1 }} />
                        </Grid>

                        <Grid item xs={6}>
                            <TextField fullWidth label="Training Start Date" name="trainingStartDate" type="date" value={formData.trainingStartDate}
                                onChange={handleChange} InputLabelProps={{ shrink: true }} disabled={isSubmitting} />
                        </Grid>

                        <Grid item xs={6}>
                            <TextField fullWidth label="Training End Date" name="trainingEndDate" type="date" value={formData.trainingEndDate}
                                onChange={handleChange} InputLabelProps={{ shrink: true }} disabled={isSubmitting}
                                error={!!formErrors.trainingEndDate} helperText={formErrors.trainingEndDate || ''}
                                inputProps={{ min: formData.trainingStartDate }} />
                        </Grid>

                        <Grid item xs={12}>
                            <Alert severity="success" icon={<CheckCircleIcon />} sx={{ mt: 1 }}>
                                <Typography variant="body2"><strong>Update Summary:</strong></Typography>
                                <Typography variant="caption" display="block">
                                    • Status will be: <strong>{formData.status === 'Other' ? `Other: ${formData.customReason || '(reason required)'}` : formData.status}</strong>
                                </Typography>
                                <Typography variant="caption" display="block">• Name, Type, and Trainer remain unchanged</Typography>
                            </Alert>
                        </Grid>
                    </Grid>

                    <Stack direction="row" spacing={2} justifyContent="flex-end" sx={{ mt: 3 }}>
                        <Button type="button" variant="outlined" color="secondary" onClick={handleCloseUpdateModal} disabled={isSubmitting} startIcon={<CloseIcon />}>
                            Cancel
                        </Button>
                        <Button type="submit" variant="contained" color="primary" disabled={isSubmitting}
                            startIcon={isSubmitting ? <CircularProgress size={20} color="inherit" /> : <SaveIcon />}
                            sx={{ bgcolor: selectedStatus?.color, '&:hover': { bgcolor: selectedStatus?.color, opacity: 0.9 } }}>
                            {isSubmitting ? 'Updating...' : 'Update Training'}
                        </Button>
                    </Stack>
                </form>
            </Box>
        </Modal>
    );
};

// ==================== MAIN MODAL ====================
const TrainingDetailsModal = ({
    isOpen, onClose, trainings, onDeleteTraining, onGenerateBatch, onUpdateTraining,
    type, userInfo
}) => {
    const [trainers, setTrainers] = useState([]);
    const [loadingTrainers, setLoadingTrainers] = useState(false);
    const [use24HourFormat, setUse24HourFormat] = useState(true);
    const [isUpdateModalOpen, setIsUpdateModalOpen] = useState(false);
    const [selectedTrainingForUpdate, setSelectedTrainingForUpdate] = useState(null);
    const navigate = useNavigate();

    const formatTimeDisplay = (timeStr) => {
        if (!timeStr) return '';
        if ((timeStr.includes('AM') || timeStr.includes('PM')) && use24HourFormat) return convertTo24HourFormat(timeStr);
        if (!timeStr.includes('AM') && !timeStr.includes('PM') && !use24HourFormat) return convertTo12HourFormat(timeStr);
        return timeStr;
    };

    const getTrainingTimeInfo = (training) => {
        if (training.startTime && training.endTime) {
            return {
                startTime: training.startTime, endTime: training.endTime,
                timeDisplay: `${formatTimeDisplay(training.startTime)} - ${formatTimeDisplay(training.endTime)}`,
                duration: training.duration || 0, source: 'direct'
            };
        }
        if (training.type) {
            const t = extractTimeFromType(training.type);
            if (t) return { startTime: t.startTime, endTime: t.endTime, timeDisplay: `${formatTimeDisplay(t.startTime)} - ${formatTimeDisplay(t.endTime)}`, duration: training.duration || 0, source: 'type' };
        }
        if (training.timeSlotLabel) {
            const timePattern = /(\d{1,2}:\d{2}\s*(?:AM|PM|am|pm)?)\s*-\s*(\d{1,2}:\d{2}\s*(?:AM|PM|am|pm)?)/;
            const match = timePattern.exec(training.timeSlotLabel);
            if (match) return { startTime: match[1], endTime: match[2], timeDisplay: `${formatTimeDisplay(match[1])} - ${formatTimeDisplay(match[2])}`, duration: training.duration || 0, source: 'timeslot' };
            return { startTime: '', endTime: '', timeDisplay: training.timeSlotLabel, duration: training.duration || 0, source: 'timeslot' };
        }
        return { startTime: '', endTime: '', timeDisplay: 'Time not specified', duration: 0, source: 'none' };
    };

    const canViewTrainingCalendar = () => ["Tata Depot Manager", "Tata Trainer", "Tata Project Manager", "Admin", "Super Admin"].includes(type);
    const canGenerateBatch = () => ["Tata Project Manager", "Admin", "Super Admin"].includes(type);
    const canDeleteTraining = () => ["Tata Project Manager", "Admin", "Super Admin"].includes(type);
    const canUpdateTraining = () => ["Tata Project Manager", "Admin", "Super Admin"].includes(type);

    const filterTrainingsByRole = (trainingsData) => {
        if (!trainingsData || !type) return trainingsData;
        let filtered = trainingsData;
        if (type === "Tata Depot Manager" && userInfo?.depot) {
            const userDepot = userInfo.depot.trim().toLowerCase();
            filtered = trainingsData.filter(t => (t.depot || '').trim().toLowerCase() === userDepot);
        } else if (type === "Tata Trainer" && userInfo?.trainerId) {
            filtered = trainingsData.filter(t => parseInt(t.trainerId) === parseInt(userInfo.trainerId));
        }
        return filtered;
    };

    useEffect(() => {
        if (isOpen && trainings && trainings.length > 0 && canViewTrainingCalendar()) {
            fetchTrainers();
        }
    }, [isOpen, trainings]);

    const fetchTrainers = async () => {
        try {
            setLoadingTrainers(true);
            const data = await fetchAllTrainers();
            if (data?.success) setTrainers(data?.result || []);
        } catch (error) {
            console.error("Error fetching trainers:", error);
        } finally {
            setLoadingTrainers(false);
        }
    };

    const getTrainingTypeColor = (trainingType) => {
        if (!trainingType) return '#ccc';
        const t = trainingTypes.find(t => t.name === extractOriginalType(trainingType));
        return t ? t.color : '#ccc';
    };

    const getAssessmentTypeColor = (assessmentType) => {
        const t = assessmentTypeData.find(t => t.name === assessmentType);
        return t ? t.color : '#CD7F32';
    };

    const getTrainerName = (trainerId) => {
        const trainer = trainers.find(t => parseInt(t.id) === parseInt(trainerId));
        return trainer ? trainer.name : `Trainer ID: ${trainerId}`;
    };

    const getTotalTrainingHours = (training) => {
        if (!training) return 0;
        const timeInfo = getTrainingTimeInfo(training);
        const dailyDuration = timeInfo.duration || training.duration || 0;
        const trainingDays = parseInt(training.trainingDays) || extractDaysFromType(training.type) || 0;
        return dailyDuration * trainingDays;
    };

    const getTrainingScheduleInfo = (training) => {
        if (!training) return { scheduleDetails: [] };
        try {
            const start = parseISO(training.trainingStartDate);
            const end = parseISO(training.trainingEndDate);
            let current = new Date(start);
            const endDate = new Date(end);
            const scheduleDetails = [];
            if (training.batchSchedule && training.batchSchedule.length > 0) {
                training.batchSchedule.forEach((schedule) => {
                    const date = parseISO(schedule.date);
                    scheduleDetails.push({
                        date, dayOfWeek: schedule.dayOfWeek || format(date, 'EEEE'),
                        startTime: schedule.startTime || training.startTime,
                        endTime: schedule.endTime || training.endTime,
                        duration: schedule.duration || training.duration
                    });
                });
            } else {
                while (current <= endDate) {
                    scheduleDetails.push({
                        date: new Date(current), dayOfWeek: format(current, 'EEEE'),
                        startTime: training.startTime, endTime: training.endTime, duration: training.duration
                    });
                    current.setDate(current.getDate() + 1);
                }
            }
            return { scheduleDetails: scheduleDetails.sort((a, b) => a.date - b.date) };
        } catch {
            return { scheduleDetails: [] };
        }
    };

    const getTrainingDaysInfo = (training) => {
        if (!training) return { trainingDaysText: 'Not specified' };
        const trainingDays = parseInt(training.trainingDays) || extractDaysFromType(training.type) || 0;
        const actualTrainingDays = parseInt(training.actualTrainingDays) || trainingDays;
        const text = `${trainingDays} day${trainingDays !== 1 ? 's' : ''}`;
        const actual = trainingDays !== actualTrainingDays ? ` (Actual: ${actualTrainingDays} days)` : '';
        return { trainingDaysText: text + actual };
    };

    const handleNavigateToBatch = (training) => {
        if (training.batchId) navigate(`/batch/${training.batchId}`);
        else navigate('/all-batches');
        onClose();
    };

    const handleViewAllBatches = () => {
        navigate('/all-batches');
        onClose();
    };

    const handleGenerateBatchForTraining = (training) => {
        if (training.batchId) navigate(`/batch/${training.batchId}`);
        else navigate('/all-batches');
        onClose();
    };

    const formatDate = (dateString) => {
        if (!dateString) return 'N/A';
        try { return format(new Date(dateString), 'EEE, MMM dd, yyyy'); }
        catch { return 'N/A'; }
    };

    const formatDateShort = (dateString) => {
        if (!dateString) return 'N/A';
        try { return format(new Date(dateString), 'MMM dd'); }
        catch { return 'N/A'; }
    };

    const handleOpenUpdateModal = (training) => {
        setSelectedTrainingForUpdate(training);
        setIsUpdateModalOpen(true);
    };

    const handleCloseUpdateModal = () => {
        setIsUpdateModalOpen(false);
        setSelectedTrainingForUpdate(null);
    };

    const handleUpdateTrainingWrapper = async (payload) => {
        if (onUpdateTraining) {
            await onUpdateTraining(payload);
            handleCloseUpdateModal();
        }
    };

    const filteredTrainings = filterTrainingsByRole(trainings || []);

    if (isOpen && !canViewTrainingCalendar()) {
        return (
            <Modal open={isOpen} onClose={onClose}>
                <Box sx={style}>
                    <Typography variant="h6" gutterBottom>
                        <CalendarTodayIcon sx={{ mr: 1, verticalAlign: 'middle' }} />Access Denied
                    </Typography>
                    <Alert severity="warning" sx={{ mb: 2 }}>
                        <Typography variant="body2">Your role: <strong>{type}</strong></Typography>
                    </Alert>
                    <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end' }}>
                        <Button onClick={onClose} variant="contained">Close</Button>
                    </Box>
                </Box>
            </Modal>
        );
    }

    return (
        <>
            <Modal open={isOpen} onClose={onClose}>
                <Box sx={style}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                        <Typography variant="h6" component="h2">
                            <CalendarTodayIcon sx={{ mr: 1, verticalAlign: 'middle' }} />
                            Trainings on Selected Date
                            <Chip label={type} size="small" color="primary" sx={{ ml: 2 }} />
                        </Typography>
                        <Tooltip title={use24HourFormat ? "Switch to 12-hour format" : "Switch to 24-hour format"}>
                            <Button size="small" variant="outlined" onClick={() => setUse24HourFormat(!use24HourFormat)} startIcon={<TwentyFourMpIcon />}>
                                {use24HourFormat ? "24h Format" : "12h Format"}
                            </Button>
                        </Tooltip>
                    </Box>

                    <Alert severity="info" sx={{ mb: 2 }}>
                        <Typography variant="body2">
                            {type === "Tata Depot Manager" && userInfo?.depot && <>Showing trainings for depot: <strong>{userInfo.depot}</strong></>}
                            {type === "Tata Trainer" && <>Showing trainings for: <strong>{userInfo.userName || 'you'}</strong></>}
                            {["Tata Project Manager", "Admin", "Super Admin"].includes(type) && <>Showing all trainings</>}
                        </Typography>
                    </Alert>

                    <Box sx={{ mb: 3, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Button variant="outlined" color="primary" startIcon={<ListIcon />} onClick={handleViewAllBatches} size="small">
                            View All Batches
                        </Button>
                        <Typography variant="caption" color="text.secondary">
                            {filteredTrainings?.length || 0} training(s) found
                        </Typography>
                    </Box>

                    {filteredTrainings && filteredTrainings.length > 0 ? (
                        <Box sx={{ width: '100%' }}>
                            {filteredTrainings.map((training, index) => {
                                if (!training) return null;
                                const trainingTypeColor = getTrainingTypeColor(training.type);
                                const assessmentTypeColor = getAssessmentTypeColor(training.technicalAssessmentType);
                                const trainerName = getTrainerName(training.trainerId);
                                const timeInfo = getTrainingTimeInfo(training);
                                const totalHours = getTotalTrainingHours(training);
                                const trainingDaysInfo = getTrainingDaysInfo(training);
                                const scheduleInfo = getTrainingScheduleInfo(training);
                                const isPastDate = training.isPastDate || isDateInPast(training.trainingStartDate);
                                const isTechnicalTraining = training.isTechnicalTraining || training.type?.includes('Technical');
                                const originalType = extractOriginalType(training.type);
                                const dateRange = getDateRangeString(training.trainingStartDate, training.trainingEndDate);
                                const statusInfo = getStatusInfo(training.status);

                                return (
                                    <React.Fragment key={training.id || index}>
                                        <Card sx={{ mb: 2, borderLeft: `4px solid ${trainingTypeColor}` }}>
                                            <CardContent>
                                                <Grid container spacing={2}>
                                                    <Grid item xs={12}>
                                                        <Stack direction="row" justifyContent="space-between" alignItems="flex-start">
                                                            <Box sx={{ flex: 1 }}>
                                                                <Typography variant="h6" fontWeight="bold" gutterBottom>
                                                                    {training.name || 'Unnamed Training'}
                                                                    {isPastDate && (
                                                                        <Tooltip title="Past dates">
                                                                            <WarningIcon sx={{ ml: 1, color: 'warning.main', fontSize: '1rem' }} />
                                                                        </Tooltip>
                                                                    )}
                                                                </Typography>
                                                                <Stack direction="row" spacing={1} sx={{ mt: 0.5, flexWrap: 'wrap', gap: 0.5 }}>
                                                                    <Chip label={originalType || training.type} size="small" sx={{ backgroundColor: trainingTypeColor, color: 'white' }} />
                                                                    {dateRange && <Chip label={`📅 ${dateRange}`} size="small" color="primary" variant="outlined" />}
                                                                    {totalHours > 0 && <Chip label={`${totalHours} total hrs`} size="small" color="secondary" variant="outlined" />}
                                                                    {isTechnicalTraining && training.technicalAssessmentType && (
                                                                        <Chip label={`${training.technicalAssessmentType} Assessment`} size="small"
                                                                            sx={{ backgroundColor: assessmentTypeColor, color: 'white' }} />
                                                                    )}
                                                                    {training.batchId && <Chip label="Batch Created" size="small" color="success" />}
                                                                    {training.status && (
                                                                        <Chip label={`${statusInfo.icon} ${statusInfo.label}`} size="small"
                                                                            sx={{ backgroundColor: statusInfo.bgColor, color: statusInfo.color, fontWeight: 'bold', border: `1px solid ${statusInfo.color}` }} />
                                                                    )}
                                                                    <Chip label={`📋 ${training.trainingMode || 'N/A'}`} size="small" color="info" variant="outlined" />
                                                                    <Chip label={`📊 Plan: ${training.batchPlan || 'N/A'}`} size="small" color="secondary" variant="outlined" />
                                                                </Stack>
                                                            </Box>
                                                            <Stack direction="row" spacing={0.5}>
                                                                {canGenerateBatch() && !training.batchId && (
                                                                    <Tooltip title="Generate Batch">
                                                                        <IconButton size="small" onClick={() => handleGenerateBatchForTraining(training)}
                                                                            sx={{ backgroundColor: '#4caf50', color: 'white' }}>
                                                                            <OpenInNewIcon fontSize="small" />
                                                                        </IconButton>
                                                                    </Tooltip>
                                                                )}
                                                                {training.batchId && (
                                                                    <Tooltip title="Open Batch">
                                                                        <IconButton size="small" onClick={() => handleNavigateToBatch(training)}
                                                                            sx={{ backgroundColor: '#2196f3', color: 'white' }}>
                                                                            <OpenInNewIcon fontSize="small" />
                                                                        </IconButton>
                                                                    </Tooltip>
                                                                )}
                                                                {canUpdateTraining() && onUpdateTraining && (
                                                                    <Tooltip title="Update Training">
                                                                        <IconButton size="small" onClick={() => handleOpenUpdateModal(training)}
                                                                            sx={{ backgroundColor: '#ff9800', color: 'white' }}>
                                                                            <EditIcon fontSize="small" />
                                                                        </IconButton>
                                                                    </Tooltip>
                                                                )}
                                                                {canDeleteTraining() && (
                                                                    <Tooltip title="Delete Training">
                                                                        <IconButton size="small" onClick={() => onDeleteTraining && onDeleteTraining(training.id)} color="error">
                                                                            <DeleteIcon fontSize="small" />
                                                                        </IconButton>
                                                                    </Tooltip>
                                                                )}
                                                            </Stack>
                                                        </Stack>
                                                    </Grid>

                                                    <Grid item xs={12}>
                                                        <Stack spacing={2}>
                                                            <Paper elevation={0} sx={{ p: 2, bgcolor: '#f8f9fa', borderRadius: 2 }}>
                                                                <Typography variant="subtitle2" fontWeight="bold" gutterBottom>Basic Information</Typography>
                                                                <Grid container spacing={2}>
                                                                    <Grid item xs={6}>
                                                                        <Stack direction="row" spacing={1} alignItems="center">
                                                                            <LocationOnIcon fontSize="small" color="action" />
                                                                            <Box>
                                                                                <Typography variant="caption" color="text.secondary">Location</Typography>
                                                                                <Typography variant="body2" fontWeight="medium">{training.depot || 'N/A'}, {training.state || 'N/A'}</Typography>
                                                                            </Box>
                                                                        </Stack>
                                                                    </Grid>
                                                                    <Grid item xs={6}>
                                                                        <Stack direction="row" spacing={1} alignItems="center">
                                                                            <PersonIcon fontSize="small" color="action" />
                                                                            <Box>
                                                                                <Typography variant="caption" color="text.secondary">Trainer</Typography>
                                                                                <Typography variant="body2" fontWeight="medium">
                                                                                    {loadingTrainers ? <CircularProgress size={12} /> : trainerName}
                                                                                </Typography>
                                                                            </Box>
                                                                        </Stack>
                                                                    </Grid>
                                                                </Grid>
                                                            </Paper>

                                                            <Paper elevation={0} sx={{ p: 2, bgcolor: '#f8f9fa', borderRadius: 2 }}>
                                                                <Typography variant="subtitle2" fontWeight="bold" gutterBottom>Schedule Information</Typography>
                                                                <Grid container spacing={2}>
                                                                    <Grid item xs={6}>
                                                                        <Stack spacing={1}>
                                                                            <Stack direction="row" spacing={1} alignItems="center">
                                                                                <TodayIcon fontSize="small" color="action" />
                                                                                <Box>
                                                                                    <Typography variant="caption" color="text.secondary">Start Date</Typography>
                                                                                    <Typography variant="body2" fontWeight="medium">{formatDate(training.trainingStartDate)}</Typography>
                                                                                </Box>
                                                                            </Stack>
                                                                            <Stack direction="row" spacing={1} alignItems="center">
                                                                                <EventRepeatIcon fontSize="small" color="action" />
                                                                                <Box>
                                                                                    <Typography variant="caption" color="text.secondary">Training Days</Typography>
                                                                                    <Typography variant="body2" fontWeight="medium">{trainingDaysInfo.trainingDaysText}</Typography>
                                                                                </Box>
                                                                            </Stack>
                                                                        </Stack>
                                                                    </Grid>
                                                                    <Grid item xs={6}>
                                                                        <Stack spacing={1}>
                                                                            <Stack direction="row" spacing={1} alignItems="center">
                                                                                <CalendarMonthIcon fontSize="small" color="action" />
                                                                                <Box>
                                                                                    <Typography variant="caption" color="text.secondary">End Date</Typography>
                                                                                    <Typography variant="body2" fontWeight="medium">{formatDate(training.trainingEndDate)}</Typography>
                                                                                </Box>
                                                                            </Stack>
                                                                            <Stack direction="row" spacing={1} alignItems="center">
                                                                                <EventNoteIcon fontSize="small" color="action" />
                                                                                <Box>
                                                                                    <Typography variant="caption" color="text.secondary">Date Range</Typography>
                                                                                    <Typography variant="body2" fontWeight="medium" color="primary">{dateRange || 'N/A'}</Typography>
                                                                                </Box>
                                                                            </Stack>
                                                                        </Stack>
                                                                    </Grid>
                                                                </Grid>
                                                            </Paper>

                                                            <Paper elevation={0} sx={{ p: 2, bgcolor: '#f8f9fa', borderRadius: 2 }}>
                                                                <Typography variant="subtitle2" fontWeight="bold" gutterBottom>Time Information</Typography>
                                                                <Grid container spacing={2}>
                                                                    <Grid item xs={6}>
                                                                        <Stack direction="row" spacing={1} alignItems="center">
                                                                            <ScheduleIcon fontSize="small" color="action" />
                                                                            <Box>
                                                                                <Typography variant="caption" color="text.secondary">Daily Timing</Typography>
                                                                                <Typography variant="body2" fontWeight="medium">{timeInfo.timeDisplay}</Typography>
                                                                            </Box>
                                                                        </Stack>
                                                                    </Grid>
                                                                    <Grid item xs={6}>
                                                                        <Stack direction="row" spacing={1} alignItems="center">
                                                                            <AccessTimeIcon fontSize="small" color="action" />
                                                                            <Box>
                                                                                <Typography variant="caption" color="text.secondary">Total Hours</Typography>
                                                                                <Typography variant="body2" fontWeight="medium">{totalHours} hours</Typography>
                                                                            </Box>
                                                                        </Stack>
                                                                    </Grid>
                                                                </Grid>
                                                            </Paper>
                                                        </Stack>
                                                    </Grid>

                                                    {canUpdateTraining() && onUpdateTraining && (
                                                        <Grid item xs={12}>
                                                            <Button variant="outlined" color="warning" fullWidth size="small"
                                                                onClick={() => handleOpenUpdateModal(training)} startIcon={<EditIcon />}>
                                                                Update Training Status
                                                            </Button>
                                                        </Grid>
                                                    )}
                                                </Grid>
                                            </CardContent>
                                        </Card>
                                        {index < filteredTrainings.length - 1 && <Divider sx={{ my: 2 }} />}
                                    </React.Fragment>
                                );
                            })}
                        </Box>
                    ) : (
                        <Box sx={{ textAlign: 'center', py: 4 }}>
                            <Typography variant="body1" color="text.secondary">No trainings found</Typography>
                        </Box>
                    )}

                    <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end' }}>
                        <Button onClick={onClose} variant="contained">Close</Button>
                    </Box>
                </Box>
            </Modal>

            {/* ✅ UpdateTrainingForm is now TOP-LEVEL — no more blinking */}
            <UpdateTrainingForm
                isUpdateModalOpen={isUpdateModalOpen}
                selectedTrainingForUpdate={selectedTrainingForUpdate}
                handleCloseUpdateModal={handleCloseUpdateModal}
                handleUpdateTraining={handleUpdateTrainingWrapper}
                getTrainerName={getTrainerName}
                canUpdateTraining={canUpdateTraining}
            />
        </>
    );
};

export default TrainingDetailsModal;